import { Stack, useColorModeValue } from "@chakra-ui/react";
import { IoWarningOutline } from "react-icons/all";
import { IconProps } from "@chakra-ui/icon/dist/types/icon";

import { Icon } from "components/Icon";
import { useGetThemeColors } from "ChakraTheme";

import { MessageContainer } from "./MessageContainer";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {
  iconProps?: IconProps;
}

const WarningWidget = ({ children, iconProps }: IProps) => {
  const colors = useGetThemeColors();
  const yellowColor = useColorModeValue(colors.yellow[500], colors.white);

  return (
    <MessageContainer>
      <Stack direction={{ base: "column", md: "row" }}>
        <Icon
          w={{ base: 50, md: 100 }}
          h={{ base: 50, md: 100 }}
          alignSelf="center"
          color={yellowColor}
          icon={IoWarningOutline}
          {...iconProps}
        />
        {children}
      </Stack>
    </MessageContainer>
  );
};

export { WarningWidget };
